import { createSlice } from '@reduxjs/toolkit';

import { contentListAdaptater } from './content.list.selectors';
import { State } from './content.list.types';
import { searchContents } from './content.list.thunks';

export const initialState: State = contentListAdaptater.getInitialState({
  metadata: {
    total: 0,
    loading: false,
  },
  errors: null,
});

export const { reducer: contentListReducer, actions: contentListActions } = createSlice({
  name: 'content/list',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(searchContents.pending, (state) => {
      state.metadata.loading = true;
    });
    builder.addCase(searchContents.fulfilled, (state, action) => {
      if (action.meta.arg.offset === 0) {
        contentListAdaptater.setAll(state, action.payload.items);
      } else {
        contentListAdaptater.addMany(state, action.payload.items);
      }

      state.metadata.loading = false;
      state.metadata.total = action.payload.metadata.total;
      state.errors = null;
    });
    // TODO: handle error
  },
});
